<script setup lang="ts">
import DataTable from 'primevue/datatable';
import Column from 'primevue/column';
import Tag from 'primevue/tag';
import { UserDocumentStatus } from '@/types/verification-types';

// -----
// Props
// -----

const props = withDefaults(
  defineProps<{
    usersDocumentStatus?: UserDocumentStatus[];
  }>(),
  {
    usersDocumentStatus: () => [],
  },
);
</script>

<template>
  <DataTable :value="props.usersDocumentStatus" :class="$style['table']">
    <Column field="name" header="Name"></Column>
    <Column field="documentStatus" header="Document Status">
      <template #body="slotProps">
        <Tag
          :severity="
            slotProps.data.documentStatus === 'Complete' ? 'success' : 'warning'
          "
          :value="slotProps.data.documentStatus"
        ></Tag>
      </template>
    </Column>
  </DataTable>
</template>

<style module lang="less">
@media screen and (min-width: 960px) {
  .table {
    display: inline-block;
  }
}
</style>
